<template>
  <!-- 普通帖子详情 -->
  <div class="main-details yunxu">
    <div class="content">
      <div class="user_info">
        <img class="img" :src="iepUserDTO && iepUserDTO.headPicUrl" alt="" />
        <div class="info">
          <div class="txt1" v-if="`${detailData.userIdentity}` === '2'">
            管理员
          </div>
          <div class="txt1 txt2" v-else>{{ iepUserDTO && iepUserDTO.realName }}</div>
          <div class="txt2">
            <template v-if="`${detailData.kind}` !== '2'">
              <span class="txt2-tag tag-admin"
                v-if="`${detailData.userIdentity}` === '2' && `${detailData.type}` === '4'">{{ detailData.tutorName ?
          `代${detailData.tutorName}导师发布` : '代专区导师发布' }}</span>
              <span class="txt2-tag tag2" v-else-if="`${detailData.userIdentity}` === '1'">{{
          userTypeObj[detailData.userIdentity] }}</span>
              <span class="txt2-tag tag-user" v-else>{{ userTypeObj[detailData.userIdentity] }}</span>
            </template>
            <span class="txt2-time">{{ detailData.time }}</span>
          </div>
        </div>
      </div>
      <div class="all">
        <p class="title">{{ detailData.subjectName }}</p>
        <div class="doc_open">
          <div class="doc_content" :class="!isOpen ? 'open' : ''" v-html="detailData.content"></div>
          <div v-if="showBtn" class="btn" :class="isOpen ? 'open' : 'close'" @click="isOpen = !isOpen">{{ isOpen ? '收起' : '展开' }}</div>
        </div>
        <div class="img-cover-list" v-if="files.length > 0 && !detailData.adminMaterialVideoId">
          <img v-for="(item_img, index_img) in files" :key="index_img" :src="item_img.url"
            @click="handleClickImg(index_img)" class="img-cover" alt="" />
        </div>
        <div class="custom-mask" @click="hidePreviewIfMaskClicked">
          <van-image-preview ref="imagePreview" v-model="showPreview" :images="images" :closeable="true" :start-position="initialIndex" />
        </div>
        <!-- 视频 -->
        <div class="video-block" v-if="analysisVideo && Object.keys(analysisVideo).length > 0 && isPlayVideo"
          @click="handleClickItemsVideo">
          <div v-if="detailData.coverInfo" :style="`background-image: url(${detailData.coverInfo.url});`" class="video-block"
            alt="">
          </div>
          <div v-else :style="`background-image: url(${analysisVideo.outUrl || analysisVideo.path});`" class="video-block"
            alt="">
          </div>
          <img src="@/assets/images/course/icon-play-course.png" class="icon-play" alt="">
        </div>
        <VideoPlayer v-else-if="!isPlayVideo" ref="video" :playerVideo="analysisVideo"></VideoPlayer>
        <!-- <VideoPlayer ref="video" v-else-if="analysisVideo && Object.keys(analysisVideo).length > 0" :playerVideo="analysisVideo" /> -->
        <div class="video-block" v-if="liveDTO && Object.keys(liveDTO).length > 0 && isPlayVideo"
          @click="handleClickLive(liveDTO)" v-track="{ functionName: '班级帖子详情-直播' }">
          <div :style="`background-image: url(${liveDTO.liveCover});`" class="video-block" alt=""></div>
          <div class="bg-div"></div>
          <div class="items-con">
            <div class="con-txt">{{ liveDTO.liveTitle }}</div>
            <div class="con-btn">进入</div>
          </div>
        </div>
      </div>
      <template v-if="`${detailData.kind}` === '1'">
        <template v-if="detailData.voteListSelectedDTOS && detailData.voteListSelectedDTOS.length > 0">
          <div class="vote-list">
            <div class="vote-show-div" :class="detailData.voteAll ? 'auto' : ''">
              <div class="vote-item" v-for="(item_vote, index_vote) in detailData.voteListSelectedDTOS"
                :key="index_vote" :class="item_vote.isSelected ? 'item-checked' : 'item-not-checked'"
                @click.stop="handleClickVoteItems(index_vote)">
                <!-- <span class="txt">{{ item_vote.content }}</span> -->
                <div class="txt-block">
                  <span class="txt">
                    {{ item_vote.content }}
                  </span>
                  <img v-if="item_vote.isSelected" src="@/assets/images/zone/img39.png"
                    :style="`left: ${(item_vote.content.length + 1) * 17}px;`" class="icon-checked" alt="">
                </div>
                <div class="process" :style="`width: ${item_vote.selectNum / detailData.allVotePerson * 100}%;`"></div>
                <!-- <img v-if="item_vote.isSelected" src="@/assets/images/zone/img39.png"
                  :style="`left: ${(item_vote.content.length + 1) * 17}px;`" class="icon-checked" alt=""> -->
                <span class="num-txt">{{ item_vote.selectNum }}</span>
              </div>
            </div>
            <div v-if="isChecked && (type !== 'dcc' || detailData.auditStatus)" class="vote-item item-submit" @click.stop="handleSubmitVote">提交</div>
            <div class="work-tip">
              <div class="left-txt">{{ detailData.cutTimeStr }}</div>
              <div class="right-txt">{{ detailData.voteNum > 0 ? detailData.voteNum : 0 }}人参与</div>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="block-flex" v-if="areaPostbarWorkDataDTOS && areaPostbarWorkDataDTOS.length > 0">
            <div class="label-txt">关联内容</div>
            <div class="val-con">
              <div class="con-item" v-for="(item, index) in areaPostbarWorkDataDTOS" :key="index"
                @click="handleClickItems(item)">
                <div class="item-cover">
                  <img :src="item.cover" class="cover" alt="">
                  <div class="item-tag">{{ contentType[item.type] }}</div>
                </div>
                <div class="item-txt">{{ item.title }}</div>
              </div>
            </div>
          </div>
        </template>
      </template>
      <commentPop :detailData="detailData" :files="files" :isAuthority="isAuthority" :isComment="isComment" :roles="roles"></commentPop>
    </div>
    <comment :postId="postId" :detailData="detailData" ref="comment"></comment>
    <returnBack></returnBack>
  </div>
</template>

<script>
import userAvatar from '../../assets/student/student.png'
import VideoPlayer from '../home/components/VideoPlayerAnswer.vue'
import commentPop from './components/commentPop.vue'
import { filesInfo, selectStock, votePostSelected } from '@/api/zone'
import { postCardDetails } from '@/api/grade'
import { contentType, userTypeObj } from './data'
import { setSha, traceClickURL, debounce } from '@/utils/util'
import { getShareInfo } from '@/utils/wxShare'
import returnBack from './components/returnBack.vue'
import { ImagePreview } from 'vant'
import withRouteTracking from '@/utils/withRouteTracking'
import comment from './comment.vue'
import {isScorm} from '../../api/scorm'
const UserProfile = {
  data () {
    return {
      detailData: {},
      userAvatar,
      iepUserDTO: {},
      files: [],
      analysisVideo: {},
      isPlayVideo: true,
      liveDTO: {},
      contentType: contentType,
      isComment: false,
      roles: {},
      areaPostbarWorkDataDTOS: [],
      voteChanges: [],
      userTypeObj,
      type: '',
      isOpen: false,
      showBtn: false,
      showPreview: false,
      images: [],
      initialIndex: 0,
      isDragging: false,
      dragStartX: 0,
      isChecked: false
    }
  },
  components: { VideoPlayer, commentPop, returnBack, ImagePreview, comment },
  computed: {
    userInfo () {
      return this.$store.getters.userInfo
    },
    isTutor () {
      return `${this.roles.tutorSign}` !== '1' || (`${this.roles.tutorSign}` === '1' && (!this.detailData.tutorId || this.detailData.tutorId === this.userInfo.id))
    },
    postId () {
      return this.$route.query.postId
    }
  },
  created() {
    this.isAuthority = Boolean(this.$route.query.isAuthority)
    window.sessionStorage.setItem('mainId', this.postId)
    window.sessionStorage.setItem('serviceId', this.postId)
    let entrance = (this.$route.query.entrance) ? this.$route.query.entrance : ''
    window.sessionStorage.setItem('entrance', entrance)
    if (entrance === '91') {
      sessionStorage.setItem('moduleName', '我的帖子')
    }
    if (entrance === '53') {
      sessionStorage.setItem('moduleName', 'RTC专区')
    }
    if (entrance === '55') {
      sessionStorage.setItem('moduleName', '班级')
    }
  },
  mounted () {
    if (this.$route.query.type === 'comment') {
      this.isComment = true
    }
    this.type = this.$route.query.type
    this.classId = this.$route.query.classId
    postCardDetails(this.postId).then(res => {
      this.detailData = res.data
      this.detailData.time = this.$moment(this.detailData.createTime * 1).format('MM-DD HH:mm')
      this.detailData.curTimes = this.detailData.cutTime ? this.$moment(this.detailData.cutTime * 1).format('YYYY/MM/DD HH:mm') : ''
      if (this.detailData.voteListSelectedDTOS && this.detailData.voteListSelectedDTOS.length > 0) {
        this.detailData.allVotePerson = 0
        this.detailData.voteListSelectedDTOS.map(items => {
          this.detailData.allVotePerson += items.selectNum
        })
        this.detailData.voteAll = !(this.detailData.voteListSelectedDTOS.length > 3)
        this.isChecked = !(this.detailData.voteListSelectedDTOS.filter(item => item.isSelected).length > 0)
      }
      this.iepUserDTO = this.detailData.iepUserDTO
      this.liveDTO = this.detailData.liveDTO
      this.areaId = this.detailData.classId
      this.areaPostbarWorkDataDTOS = this.detailData.areaPostbarWorkDataDTOS
      if (this.detailData.auditStatus !== 1) {
        this.detailData.adminFileMainId = this.postId
      }
      this.$forceUpdate()
      const getPlainTextLen = richText => richText
        .replace(/<[^>]+>/g, '')
        .replace(/ |\n|\r\n|&nbsp;|&ensp;/g, '')
        .replace(/[a-zA-Z]&#7([6-7][0-9]);/g, ' ')
        .replace(/&([a-z]{2,5}|#[0-9]{1,6});/g, ' ')
        .length
      if (this.detailData.content && getPlainTextLen(this.detailData.content) > 100) {
        this.showBtn = true
      }
      this.handleFun()
    })
  },
  methods: {
    handleMouseDown (event) {
      if (!this.showPreview || event.buttons !== 1) return // 只处理左键按下

      // 开始拖动
      this.isDragging = true
      this.dragStartX = event.clientX

      // 添加鼠标移动和释放的监听器
      document.addEventListener('mousemove', this.handleMouseMove)
      document.addEventListener('mouseup', this.handleMouseUp)
    },
    handleMouseMove (event) {
      if (!this.isDragging) return

      // 计算拖动距离
      this.deltaX = event.clientX - this.dragStartX

      // 重置起点
      // this.dragStartX = event.clientX
    },
    handleMouseUp () {
      if (!this.isDragging) return
      // 根据拖动方向切换图片
      if (this.deltaX > 50 && this.initialIndex > 0) {
        this.initialIndex--
      } else if (this.deltaX < -50 && this.initialIndex < this.images.length - 1) {
        this.initialIndex++
      }
      // 结束拖动
      this.isDragging = false
      // 移除鼠标移动和释放的监听器
      document.removeEventListener('mousemove', this.handleMouseMove)
      document.removeEventListener('mouseup', this.handleMouseUp)
    },
    // 点击关闭
    hidePreviewIfMaskClicked (event) {
      // 判断点击是否发生在预览图片本身之外
      if (event.target.classList.contains('van-image-preview__swipe-item')) {
        this.showPreview = false
        document.removeEventListener('mousedown', this.handleMouseDown)
      }
    },
    // 点击放大图片
    handleClickImg (index) {
      this.images = this.files.map(res => res.url)
      this.initialIndex = index
      this.showPreview = true
      document.addEventListener('mousedown', this.handleMouseDown)
    },
    // 点击提交投票
    handleSubmitVote: debounce(function() {
      if (this.voteChanges.length <= 0) {
        this.$toast('请至少选择一项或者修改一项！')
        return
      }
      if (`${this.detailData.selectType}` === '2' && this.voteChanges.length <= 1) {
        this.$toast('该投票为多选，请至少选择一个以上！')
        return
      }
      votePostSelected({ voteSelectROS: this.voteChanges }).then(res => {
        this.isChecked = false
        this.voteChanges = []
        this.$toast('投票成功')
      })
    }, 500),
    // 点击选择投票
    handleClickVoteItems (indexVote) {
      if (!this.isChecked) return
      if (`${this.detailData.selectType}` === '2') {
        this.detailData.voteListSelectedDTOS[indexVote].isSelected = !this.detailData.voteListSelectedDTOS[indexVote].isSelected
        if (this.detailData.voteListSelectedDTOS[indexVote].isSelected) {
          this.detailData.voteListSelectedDTOS[indexVote].selectNum++
          this.detailData.allVotePerson++
        } else {
          this.detailData.voteListSelectedDTOS[indexVote].selectNum--
          this.detailData.allVotePerson--
        }
      } else {
        if (this.detailData.voteListSelectedDTOS[indexVote].isSelected) return
        this.detailData.voteListSelectedDTOS[indexVote].selectNum++
        this.detailData.allVotePerson++
        this.detailData.voteListSelectedDTOS.map((res) => {
          if (res.isSelected) {
            res.selectNum--
            this.detailData.allVotePerson--
          }
          res.isSelected = false
        })
        this.detailData.voteListSelectedDTOS[indexVote].isSelected = 1
      }

      this.voteChanges = this.detailData.voteListSelectedDTOS.filter(res => res.isSelected).map(res => {
        return {
          voteId: res.id,
          postbarId: res.postbarId,
          userId: this.userInfo.id
        }
      })
    },
    // 根据详情返回id来获取附件内容
    handleFun () {
      if (!this.classId) {
        this.roles = {
          peSign: 0,
          studentSign: 1,
          studentStatus: 1,
          tutorSign: 0
        }
      } else {
        this.roles = JSON.parse(sessionStorage.getItem('roleResult'))
      }
      if (this.detailData.adminFileMainId) {
        filesInfo({ mainId: this.detailData.adminFileMainId }).then((res) => {
          this.files = res.data
          if (this.files && this.files.length > 0) {
            this.handleShare(this.files, 'images')
          } else if (!this.detailData.adminMaterialVideoId) {
            this.handleShare(this.files, 'images')
          }
          if (this.files && this.files.length <= 0 && this.detailData.adminMaterialVideoId) {
            selectStock({ mainId: this.detailData.adminMaterialVideoId }).then((res) => {
              this.analysisVideo = res.data
              this.handleShare(this.analysisVideo, 'videos')
            })
          }
        })
      }
    },
    handleShare(file, type) {
      // window.sessionStorage.setItem('traceTitle', this.detailData.subjectName)
      // let desc = '更智慧、更全面、更懂你。'
      // 类别1RTC2图文专区3心电图交流
      let roleResult = JSON.parse(sessionStorage.getItem('roleResult'))
      let desc = `${this.detailData.kind}` === '2' ? this.detailData.iepUserDTO ? `${this.detailData.iepUserDTO.realName}\n${this.detailData.iepUserDTO.hospitalName}` : '' : roleResult && roleResult.hospitalName ? `RTC专区：${roleResult && roleResult.hospitalName}` : ''
      let images = ''
      if (type === 'images') {
        images = this.files && this.files.length > 0 ? this.files[0].url : `https://iep.jjmc.cn/bw/file/material/image/1933146816339349528.jpg`
      } else if (type === 'videos') {
        if (this.detailData.coverInfo && this.detailData.coverInfo.url) {
          images = this.detailData.coverInfo.url
        } else if (file && file.path) {
          images = file.path
        } else {
          images = `https://iep.jjmc.cn/bw/file/material/image/1933146816339349528.jpg`
        }
      }
      getShareInfo({
        title: this.detailData.subjectName,
        titleTimeLine: this.detailData.subjectName,
        desc,
        link: window.location.href, // modifyURLParam(window.location.href, 'entrance', '20'),
        linkTimeLine: window.location.href, // modifyURLParam(window.location.href, 'entrance', '21'),
        images,
      })
    },
    handleClickItemsVideo () {
      this.isPlayVideo = !this.isPlayVideo
      setTimeout(() => {
        let videos = this.$refs.video
        videos.player.play()
      })
    },
    handleClickLive (item) {
      if (`${item.type}` === '1') {
        localStorage.setItem('functionUrl', `${process.env.baseURL}${process.env.BASE_URL}/liveDetails?liveId=${item.liveId}&businessId=${this.$route.query.classId}&entrance=55&channel=55`)
        this.$router.push({
          path: '/liveDetails',
          query: {
            liveId: item.liveId,
            businessId: this.$route.query.classId,
            entrance: 55,
            channel: 55,
          },
        })
      } else {
        window.location.href = item.liveId
      }
    },
    async handleClickItems (item) {
      // if (rolesClick(this.roles, this.userInfo)) return
      // let trackParams = `&entrance=4`
      window.sessionStorage.setItem('entrance', '55')
      let trackParams = `&entrance=55&businessChannel=55&campId=${this.classId}`
      if (item.type === 1) {
        this.$router.push({
          path: '/articleDetails',
          query: {
            id: item.baseId,
            areaId: this.$route.query.classId,
            classId: this.detailData.classId,
            businessId: this.detailData.classId,
            entrance: '55',
            channel: '55'
          }
        })
        // setTimeout(() => { traceClickURL() })
        // let openid = `&unionid=${this.userInfo.unionId}&openid=${this.userInfo.iepOpenId}${setSha(`xxbiep${this.userInfo.iepOpenId}`)}`
        // let iepTxt = `&nickname=123&avatar=123&subscribe=1`
        // window.location.href = `${process.env.iepUrl}/mobile/home/article-detail?index=0&id=${item.baseId}${openid}${iepTxt}${trackParams}`
      } else if (item.type === 3) {
        setTimeout(() => { traceClickURL() })
        let openidBindli = `&unionid=${this.userInfo.unionId}&openid=${this.userInfo.iepOpenId}${setSha(`xxbiep${this.userInfo.iepOpenId}`)}`
        window.location.href = `${process.env.bingliUrl}/wap/index.html#/casedetails?id=${item.baseId}${openidBindli}${trackParams}`
      } else if (item.type === 2) {
        const query = {
          courseId: item.baseId,
          areaId: this.$route.query.classId,
          classId: this.detailData.classId,
          businessId: this.detailData.classId,
          entrance: '55',
          channel: '55'
        }
        const isscorm = await isScorm(item.baseId)
        let path = '/courserDetails'
        if (isscorm.data) {
          path = '/scormCourseDetail'
        }
        this.$router.push({path, query})
      }
    },
    handleClickWork (item, type) {
      let path, query
      path = '/dccDetail'
      query = {
        postId: item.id,
        areaId: this.$route.query.classId,
        entrance: 55,
        channel: 55,
        businessId: this.$route.query.classId,
      }
      if (type === 'answerwork') {
        path = '/answerWork'
        query = {
          postId: item.id,
          areaId: item.classId
        }
      }
      if (type === 'workdetails') {
        path = '/workDetails'
        query = {
          workId: item.areaPostbarWorkDTO[0].id,
          workType: 'answer',
          areaId: this.$route.query.classId
        }
      }
      if (type === 'worklist') {
        path = '/workList'
        query = {
          postId: item.id,
          areaId: this.$route.query.classId
        }
      }
      this.$router.push({
        path, query
      })
    }
  }
}
export default withRouteTracking(UserProfile)
</script>

<style lang="less" scoped>
.main-details {
  padding-bottom: 60px;
  box-sizing: border-box;
}
.content {
  padding: 0 0 50px;
  padding-bottom: 20px;
  box-sizing: border-box;

  .user_info {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    width: 100%;
    height: 64px;
    padding: 10px 16px;
    box-sizing: border-box;
    background-image: url('../../assets/images/zone/img43.png');
    background-size: 100% 100%;

    .img {
      width: 44px;
      height: 44px;
      border-radius: 50%;
      margin-right: 8px;
      display: block;
    }

    .info {
      .txt1 {
        line-height: 20px;
        font-size: 14px;
        color: #EB1700;
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 500;
        margin-bottom: 2px;

        &.txt2 {
          color: #000000;
        }
      }

      .txt2 {
        display: flex;
        align-items: center;
        font-family: Source Han Sans CN, Source Han Sans CN;

        .txt2-tag {
          // width: 40px;
          height: 14px;
          border-radius: 2px;
          border: 1px solid #EB1700;
          margin-right: 4px;
          color: #EB1700;
          font-size: 10px;
          text-align: center;

          &.tag2 {
            // width: 32px;
            border-color: #0F68B2;
            color: #0F68B2;
          }

          &.tag-user {
            width: 32px;
            color: #FF6017;
            border-color: #FF6017;
          }

          &.tag-admin {
            width: auto;
            padding: 0 4px;
          }
        }

        .txt2-time {
          font-size: 12px;
          font-weight: 500;
          color: #7a8494;
          font-family: Source Han Sans CN, Source Han Sans CN;
        }
      }
    }
  }

  .all {
    padding: 0 16px;
    box-sizing: border-box;

    .title {
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 600;
      font-size: 18px;
      color: #282828;
      padding: 8px 0;
      box-sizing: border-box;
    }

    .doc_open {
      .doc_content {
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 400;
        font-size: 16px;
        color: rgba(0, 0, 0, 0.8);
        line-height: 30px;

        &.open {
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 5;
          overflow: hidden;
        }
      }

      .btn {
        width: 100%;
        font-family: PingFang HK, PingFang HK;
        font-size: 14px;
        line-height: 20px;
        color: #EB1700;
      }
    }

    .img-cover-list {
      display: flex;
      flex-wrap: wrap;
      margin-top: 8px;

      .img-cover {
        width: 110px;
        height: 110px;
        border-radius: 4px;
        margin-bottom: 4px;
        object-fit: cover;
        display: block;

        &:nth-child(3n-1) {
          margin: 0 4px;
        }
      }
    }
  }

  .vote-list {
    padding: 0 14px;
    box-sizing: border-box;
    margin-top: 15px;

    .vote-item {
      width: 100%;
      padding: 6px 0;
      border: 1px solid #E8E8E8;
      box-sizing: border-box;
      margin-bottom: 6px;
      border-radius: 4px;
      color: #EB1700;
      font-size: 14px;
      line-height: 16px;
      display: flex;
      align-items: center;
      justify-content: center;

      &.item-submit {
        background-color: #EB1700;
        color: #fff;
      }

      .process {
        width: 32px;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
      }

      .txt-block {
        display: flex;
        align-items: center;

        .txt {
          position: relative;
          z-index: 1;
          max-width: 240px;
          margin-right: 10px;
        }
      }

      .num-txt {
        font-size: 14px;
        position: relative;
        z-index: 1;
      }

      &.item-checked {
        border-color: #EB1700;
        justify-content: space-between;
        padding-left: 14px;
        padding-right: 14px;
        box-sizing: border-box;
        position: relative;

        .process {
          background-color: rgba(255, 91, 12, 0.1);
        }

        .num-txt {
          color: #EB1700;
        }

        .icon-checked {
          width: 14px;
        }
      }

      &.item-not-checked {
        border-color: #E8E8E8;
        justify-content: space-between;
        padding-left: 14px;
        padding-right: 14px;
        box-sizing: border-box;
        position: relative;
        color: #333333;

        .process {
          background-color: #F6F6F6;
        }

        .num-txt {
          color: #333333;
        }
      }

      .icon-more {
        display: block;
        width: 4px;
        margin-left: 4px;
      }
    }
  }
}

.video-block {
  width: 100%;
  height: 200px;
  position: relative;
  object-fit: cover;
  position: relative;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;

  .icon-play {
    position: absolute;
    width: 40px;
    display: block;
    left: 50%;
    top: 50%;
    transform: translateX(-50%) translateY(-50%);
  }

  .bg-div {
    position: absolute;
    height: 77px;
    width: 100%;
    bottom: 0;
    left: 0;
    background: linear-gradient(360deg, rgba(0, 0, 0, .4) 0%, rgba(102, 102, 102, 0) 100%);
  }

  .items-con {
    display: flex;
    align-items: center;
    position: absolute;
    bottom: 8px;
    height: 40px;
    width: 100%;
    justify-content: space-between;
    padding: 0 8px;
    box-sizing: border-box;

    .con-txt {
      font-size: 14px;
      font-weight: 600;
      color: #fff;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      flex: 1;
    }

    .con-btn {
      width: 56px;
      height: 24px;
      border-radius: 100px;
      background-color: #fff;
      font-size: 14px;
      color: #EB1700;
      font-weight: bold;
      text-align: center;
      line-height: 24px;
    }
  }
}

.pop {
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.4);
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
}

.block-flex {
  margin: 0 16px;
  margin-top: 20px;
  padding-top: 10px;
  box-sizing: border-box;

  .label-txt {
    font-size: 16px;
    color: #202020;
    line-height: 40px;
    border-bottom: 1px solid #E8E8E8;
    font-weight: bold;
  }

  .val-con {
    .con-item {
      display: flex;
      padding: 10px 0;
      box-sizing: border-box;
      border-bottom: 1px solid #E8E8E8;

      .item-cover {
        width: 110px;
        min-width: 110px;
        object-fit: cover;
        position: relative;
        border-radius: 4px;
        margin-right: 8px;
        height: 60px;
        border-radius: 4px;

        .cover {
          display: block;
          width: 100%;
          object-fit: cover;
          height: 60px;
        }

        .item-tag {
          font-size: 12px;
          position: absolute;
          line-height: 16px;
          color: #000000;
          background-color: rgba(255, 255, 255, .6);
          padding: 2px;
          box-sizing: border-box;
          bottom: 0;
          left: 0
        }
      }

      .item-txt {
        font-size: 14px;
        color: #000000;
        line-height: 20px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        overflow: hidden;
      }
    }

    .work-div {
      display: flex;
      align-items: center;
      padding-right: 10px;
      box-sizing: border-box;
      background: linear-gradient(180deg, #FFF0EF 0%, #FFF5EE 100%);
      border-radius: 4px;
      height: 32px;
      margin-top: 10px;

      &.worked {
        background: #F6F6F6;

        .work-btn {
          background: #DFDDDD;
          color: #7A8494;
          box-shadow: none;
        }
      }

      .icon-word {
        width: 29px;
        height: 29px;
        display: block;
        margin-right: 4px;
        transform: translateY(2px);
      }

      .work-txt {
        flex: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        font-size: 14px;
        color: #202020;
        white-space: nowrap;
      }

      .work-go {
        display: flex;
        align-items: center;
        font-size: 14px;
        color: #EB1700;

        .icon-more {
          width: 13px;
          display: block;
          margin-left: 4px;
          transform: translateY(2px);
        }
      }

      .work-btn {
        background: #EB1700;
        box-shadow: 0px 2px 4px 0px rgba(255, 91, 12, 0.25);
        border-radius: 4px;
        width: 44px;
        height: 18px;
        line-height: 18px;
        color: #fff;
        font-size: 12px;
        text-align: center;
      }

      .work-check {
        display: flex;
        align-items: center;
        height: 22px;

        .icon-check {
          display: block;
          width: 22px;
          height: 22px;
          transform: translateY(2px);
        }

        .check-txt {
          padding: 0 2px;
          box-sizing: border-box;
          font-size: 14px;
          color: #EB1700;
        }

        .icon-more {
          display: block;
          width: 12px;
          transform: translateY(2px);
        }
      }
    }
  }
}

.work-tip {
  margin-top: 10px;
  height: 20px;
  display: flex;
  justify-content: space-between;

  .left-txt {
    font-size: 13px;
    color: #7A8494;
  }

  .right-txt {
    font-size: 14px;
    color: #7A8494;
  }
}
</style>

<style>
.yunxu .van-image-preview__image img{
  pointer-events: auto;
  -webkit-user-drag: auto;
}
</style>



// WEBPACK FOOTER //
// src/views/grade/topicDetail.vue